import { UserAccountApi, useAPIAction } from "melco-shared-logic";

export const useMachineLicensesAssignment = (assignmentData: any) => {
  return useAPIAction(
    UserAccountApi,
    async (api) => {
      console.log("Payload is ", JSON.stringify(assignmentData))
      const data = await api.accountEditMachineLicenseAssignment({
        melcoModelsUserMachineLicenseAssignment: assignmentData


      });

      return {
        successMessages: [
          {
            message: "default",
          },
        ],
        data,
      };
    },
    { translationPrefix: "machineLicenses.licenseAssignment.actions.save" }
  );
};
